// extracted by mini-css-extract-plugin
export default {"vertical-icon":"RolesTable_vertical-icon__dpg9w"};